import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogPost from './components/BlogPost';
import QualifyForm from './pages/QualifyForm';
import About from './pages/About';
import FAQ from './pages/FAQ';
import FAQArticle from './pages/FAQArticle';
import LearnRedirect from './pages/LearnRedirect';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import { captureReferralFromUrl } from './utils/referralSource';
import { BlogCatalogProvider } from './data/blogCatalog';
import './styles/globals.css';
import './styles/Header.css';
import './styles/Footer.css';

function App() {
  useEffect(() => {
    captureReferralFromUrl();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Header />
        <main className="main-content">
          <BlogCatalogProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/qualify" element={<QualifyForm />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/faq/:slug" element={<FAQArticle />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/learn" element={<LearnRedirect />} />
              <Route path="/learn/:slug" element={<LearnRedirect />} />
            </Routes>
          </BlogCatalogProvider>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
